import {Injectable} from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class DropdownService {

  public process(dropdownEl: HTMLDivElement, isOpened: boolean) {
    if (!isOpened) {
      dropdownEl.classList.add('expanded');
    } else {
      dropdownEl.classList.remove('expanded');
    }
  }
}
